import { type Outreach } from '@libraries/typescript/api_client';

type DriveModeOutreach = Pick<Outreach, 'drive_mode' | 'outreach_type'>;

const CAREGIVER_PICKING_OUTREACH_TYPES: ReadonlySet<Outreach['outreach_type']> =
    new Set(['callout', 'recurring_shift']);

// `drive_mode` is fail-closed, so a clock reminder, confirmation, survey or
// message also reads `manual`. Only a shift-filling outreach is ever asked.
export function isCoordinatorPickedOutreach(
    outreach: DriveModeOutreach,
): boolean {
    return (
        outreach.drive_mode === 'manual' &&
        CAREGIVER_PICKING_OUTREACH_TYPES.has(outreach.outreach_type)
    );
}
